<div class="mfa-container" fxLayout="column" style="   ">
  <div style="float:right;margin-right:10px;margin-top:10px">
    <button mat-icon-button color="primary" class="m-r-2 " style="float:right;margin-top:10px;margin-right:10px"
      [ngClass]="showHelpIcon ? 'help-icon-click' : ' help-icon'" (click)="ShowHelp()" id='myLauncher'>
      <img [hidden]="hasClass()" src="assets/img/Help.png" style="height: 24px;" alt="Help" />
      <img [hidden]="!hasClass()" src="assets/img/Help_Click.png" style="height: 24px;" alt="Help" />
    </button>
  </div>
  <div fxFlex fxLayout="column" fxLayoutAlign="center center" style="flex: 1 1 1e-9px; flex-direction: column; box-sizing: border-box; display: flex; place-content: center; align-items: center; ">

    <mat-card class="mat-card-sty" data-loader="mfa-loader">

      <div class="mfa-box">
        <div class="login-header">
          <div class="row" style="justify-content: center;">
            <img src="assets/img/logo/Transcriber_Logo.png" alt="acord_logo">
            <!-- <div class="acord-img">
              <img src="assets/img/logo/acord-logo.svg" style="width:78%">
            </div>
            <div class="line"></div>
            <div class="adept-img">
              <img src="assets/img/logo/transcriber-logo.svg" style="width:100%;height:48px">
            </div> -->
          </div>

        </div>
        <div class="login-sub-head">Welcome to Transcriber</div>

        <div class="form-group-header" style="margin-top:3%">
          <div class="form-group">
            <div class="txt1-sty">Change password</div>

          </div>
        </div>

        <app-change-password-dialog [isLoggedIn]=isLoggedIn></app-change-password-dialog>
      </div>

    </mat-card>
  </div>
</div>